import { Action } from '@ngrx/store';
import {LicenseMgt, TransferParams, LicenseMgtParam, ConfirmLicenseParams} from '../license-mgt.model';
import {Update} from '@ngrx/entity';

export enum LicenseMgtActionTypes {
  GetLicenseMgts = '[LicenseMgt] Get LicenseMgts',
  LoadLicenseMgts = '[LicenseMgt] Load LicenseMgts',
  UpdateLicenseMgts = '[LicenseMgt] Update LicenseMgts',
  DeleteLicenseMgts = '[LicenseMgt] Delete LicenseMgts',
  GetDeleteLicenseMgts = '[LicenseMgt] Get Delete LicenseMgts',
  AddLicenseMgts = '[LicenseMgt] Add LicenseMgts',
  ClearLicenseMgts = '[LicenseMgt] Clear LicenseMgts',
  TransferLicenseMgts = '[LicenseMgt] Transfer LicenseMgts',
  ConfirmLicenseMgts = '[LicenseMgt] Confirm LicenseMgts'
}


export class GetLicenseMgts implements Action {
  readonly type = LicenseMgtActionTypes.GetLicenseMgts;
}

export class LoadLicenseMgts implements Action {
  readonly type = LicenseMgtActionTypes.LoadLicenseMgts;
  constructor(public payload: LicenseMgt[]) {}
}

export class UpdateLicenseMgts implements Action {
  readonly type = LicenseMgtActionTypes.UpdateLicenseMgts;
  constructor(public payload: LicenseMgtParam) {}
}

export class DeleteLicenseMgts implements Action {
  readonly type = LicenseMgtActionTypes.DeleteLicenseMgts;
  constructor(public payload: { id: number }) {}
}

export class GetDeleteLicenseMgts implements Action {
  readonly type = LicenseMgtActionTypes.GetDeleteLicenseMgts;
  constructor(public payload: { id: number }) {}
}

export class AddLicenseMgts implements Action {
  readonly type = LicenseMgtActionTypes.AddLicenseMgts;
  constructor(public payload: LicenseMgtParam) {}
}

export class ClearLicenseMgts implements Action {
  readonly type = LicenseMgtActionTypes.ClearLicenseMgts;
}

export class TransferLicenseMgts implements Action {
  readonly type = LicenseMgtActionTypes.TransferLicenseMgts;
  constructor(public payload: TransferParams) {}
}

export class ConfirmLicenseMgts implements Action {
  readonly type = LicenseMgtActionTypes.ConfirmLicenseMgts;
  constructor(public payload: ConfirmLicenseParams) {}
}


export type LicenseMgtActions = LoadLicenseMgts
  | GetLicenseMgts
  | UpdateLicenseMgts
  | DeleteLicenseMgts
  | GetDeleteLicenseMgts
  | AddLicenseMgts
  | ClearLicenseMgts
  | TransferLicenseMgts
  | ConfirmLicenseMgts;
